import React, {Component} from 'react';
import {
    View,
    StatusBar,
    TextInput,

    BackHandler,
    Alert,
    Image,
    TouchableOpacity,
    Platform,
    KeyboardAvoidingView
} from "react-native"
import {verticalScale, moderateScale, scale} from "../../../../tools/Scaling";

import {AsyngStorageClass} from './../../../../tools/AsyngStorageClass';
import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import Colors from "../../../../tools/Colors";
import HMTextView from "../../../../customviews/HMTextView";
import DialogLoadingCustomize from "../../../../customviews/DialogLoadingCustomize";
import HMActionBar from "../../../../customviews/HMActionBar";
import i18n from "../../../../I18n/i18n";
import HMTextInputEfects from "../../../../customviews/HMTextInputEfects";
import {typeExport} from "../../../../redux/store/type";
import {Tools} from "../../../../tools/Tools";
import store from "../../../../redux/store";
import HMAlert from "../../../../customviews/HMAlert";
import FloatingLabelInput from "../../../../customviews/input/floatLabelInput";

let content = null

export default class EnterCodeScreen extends Component {
    constructor(props) {
        super(props)
        this.state = {
            code: null,
            seconds: 120
        }
        content = this;

        props.callServiceRefresh();
    }

    componentDidMount() {
        this.timeout = setInterval(() => {
            if (content.state.seconds < 1) {
                this.props.navigation.pop();
            }
            else
                content.setState({
                    seconds: content.state.seconds - 1
                })
        }, 1000);
        //     BackHandler.addEventListener('hardwareBackPress', this.handleBackPress);
    }

    componentWillUnmount() {
        if (this.timeout) {
            clearInterval(this.timeout);
        }
        //  BackHandler.removeEventListener('hardwareBackPress', this.handleBackPress);
    }

    handleBackPress = () => {
        this.goBack();

        return true;
    }

    goBack() {
        this.props.navigation.pop();
        this.props.navigation.navigate("LoginEnterPhoneScreen",
            {
                mobile: this.props.route.params.mobile,
                result_extra: this.props.route.params.result_extra,
                type_login: this.props.route.params.type_login
                /*
                          , AdvertisingChildlist: this.props.route.params.AdvertisingChildlist
                */
            }
        );
    }

    componentWillReceiveProps(propss) {
        if (propss.results != null) {
            //  this.loadingButton.showLoading(false);

            /*     if (propss.results.status == true) {

                     propss.results.user ?
                         (
                             this.props.callServiceSetToken(propss.results.user.token),
                                 this.props.callServiceSetUser(propss.results.user),
                                 this.setInfoUser(
                                     propss.results.user.token,
                                     propss.results.user.address,
                                     propss.results.user.name
                                 )
                         )
                         :
                         (
                             // Actions.information({ result_extra: propss.results, mobile: this.props.route.params.mobile, type_login: this.props.route.params.type_login, AdvertisingChildlist: this.props.route.params.AdvertisingChildlist })
                             this.props.navigation.pop(),
                                 this.props.navigation.navigate("InformationScreen", {
                                     result_extra: propss.results,
                                     mobile: this.props.route.params.mobile,
                                     type_login: this.props.route.params.type_login,
                                     AdvertisingChildlist: this.props.route.params.AdvertisingChildlist
                                 })
                         )
                 }
                 else {
                     alert(propss.results.message)
                 }*/
        }
    }

    async setInfoUser(token, address, name) {

        let value1 = await AsyngStorageClass.setInfoUser(token, address, name);
        let value2 = await AsyngStorageClass.setInfoUserMobile(this.props.route.params.mobile);
        if (value1 & value2) {

            this.props.navigation.pop();

            switch (this.props.route.params.type_login) {
                case "changeInfo":
                    this.props.navigation.navigate("ChangeInformationScreen");
                    break;


                default:
                    this.props.navigation.navigate("SplashScreen", {refreshOfLogin: true});

                //  this.props.navigation.pop();
            }
        }
        else {
            this.props.navigation.pop();
            alert(i18n.t('constant.retry'))
        }


    }

    getData(code) {
        let paramss = {
            "_operation": typeExport._verifyCode,
            "mode": typeExport._verifyCodeMode,
            "lang": i18n.locale,
            "mobile": this.props.route.params.mobile,
            "code": code,
        };
        this.props.callService(
            typeExport.urlGetEnterCodeScreen,
            paramss,
            typeExport.TypegetDataEnterCodeScreen,
            "POST"
        );

    }

    checkCode(text) {
        if (text == null) {

            HMAlert(
                i18n.t('constant.message'),
                i18n.t('constant.checkCode'),
                [
                    // {text: 'Ask me later', onPress: () => {}},
                    // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                    {
                        text: i18n.t('constant.ok'), onPress: () => {
                        }
                    },
                ],
                {cancelable: true}
            )
        }
        else {
            if (text.length < 3) {
                HMAlert(
                    i18n.t('constant.message'),
                    i18n.t('constant.WrongCodeEntered'),
                    [
                        // {text: 'Ask me later', onPress: () => {}},
                        // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                        {
                            text: i18n.t('constant.ok'), onPress: () => {
                            }
                        },
                    ],
                    {cancelable: true}
                )
                //alert(i18n.t('constant.WrongCodeEntered'))
            } else {
                //   this.loadingButton.showLoading(true);
                this.setState({
                        mobile: text,
                    }
                    ,
                    () => {
                        this.getData(text)
                    }
                );

            }
        }
    }

    _changeText(text) {
        this.setState({code: text});
    }

    render() {
        let checkLogin = (store.getState().reducerSplashGetAllData.TypeLogin == 2)

        return (
            <View style={{flex: 1}}>

                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{flex: 1,}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        <View style={{flex: 1,}}>
                            <HMActionBar
                                props={this.props} statusBarTransparent
                                text={i18n.t('code.title')}

                                //  text={i18n.t('constant.Information')}
                                menu={!checkLogin}

                                back
                                headerVisibility more_menu
                                onBackPress={() => this.props.navigation.pop()}

                            />

                            <View style={{
                                width: '100%',
                                // flexDirection: 'row',
                                backgroundColor: Colors.white,
                                padding: moderateScale(10),
                                justifyContent: 'center',
                                alignItems: 'center'
                                // marginBottom: moderateScale(8),
                            }}>

                                {/*<HMTextView text={" تا "+Tools.getTimeStringM(this.state.seconds)+" دیگر، "+i18n.t('constant.descCode')} type="bold" style={{*/}
                                {/*alignSelf: "center",*/}
                                {/*color: Colors.colorDark,*/}
                                {/*fontSize: moderateScale(13),*/}
                                {/*textAlign: 'center'*/}

                                {/*}}/>*/}

                                <HMTextView text={i18n.t('constant.descCode')} type="bold" style={{
                                    alignSelf: "center",
                                    color: Colors.colorDark,
                                    fontSize: moderateScale(13),
                                    textAlign: 'center'

                                }}/>
                                <HMTextView text={Tools.getTimeStringM(this.state.seconds)} type="bold" style={{
                                    alignSelf: "center",
                                    color: Colors.colorDark,
                                    fontSize: moderateScale(13),
                                    textAlign: 'center'

                                }}/>

                            </View>


                            {/*     <HMTextInputEfects
                                type={"Fumi"}
                                value={this.state.code}
                                label={i18n.t('constant.ActivationCode')}
                                onChangeText={text => this._changeText(text)}
                                iconClass={"FontAwesome"}
                                iconName={'key'}
                                keyboardType="numeric"
                                styleRoot={{
                                    width: "100%", alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            />*/}

                            <FloatingLabelInput
                                label={i18n.t('constant.ActivationCode')}
                                value={this.state.code}
                                staticLabel
                                hintTextColor={'#aaa'}
                                styleRoot={{marginVertical: moderateScale(8), width: "93%", alignSelf: 'center',}}
                                //mask="99 (99) 99999-9999"
                                hint={"کد ورود پیامک شده را وارد نمایید"}
                                containerStyles={{
                                    borderWidth: moderateScale(2),
                                    paddingHorizontal: moderateScale(10),
                                    backgroundColor: '#fff',
                                    borderColor: 'blue',
                                    borderRadius: moderateScale(8),
                                }}
                                customLabelStyles={{
                                    colorFocused: 'red',
                                    fontSizeFocused: moderateScale(12),
                                }}
                                labelStyles={{
                                    backgroundColor: '#fff',
                                    paddingHorizontal: moderateScale(5),
                                }}
                                inputStyles={{
                                    color: 'blue',
                                    paddingHorizontal: moderateScale(2),
                                    marginVertical: moderateScale(2),
                                    height: moderateScale(48),
                                    outlineColor: Colors.transparent
                                }}
                                onChangeText={text => this._changeText(text)}
                                keyboardType="numeric"
                                onSubmitEditing={() => this.checkCode(this.state.code)}

                            />
                            <TouchableOpacity style={{
                                backgroundColor: Colors.colorPrimary,
                                width: "93%",
                                height: moderateScale(40),
                                alignSelf: 'center',
                                alignItems: "center",
                                justifyContent: "center",
                                marginTop: moderateScale(8),
                                borderRadius: moderateScale(6)
                                // borderRadius:moderateScale(2)
                            }}
                                              onPress={() => this.checkCode(this.state.code)}
                            >
                                <View style={{flexDirection: "row", alignItems: "center", justifyContent: "center"}}>
                                    <HMTextView type={"bold"} text={i18n.t('constant.signIn')} style={{
                                        color: "white",
                                        fontSize: moderateScale(16),
                                        marginEnd: moderateScale(10)
                                    }}/>

                                </View>
                            </TouchableOpacity>

                        </View>
                        {
                            this.props.NoInternetDialog ?
                                <DialogConnectionCustomize
                                    onPress={() => this.checkCode(this.state.code)}
                                />
                                :
                                null
                        }
                        {
                            this.props.isLoading ?
                                <DialogLoadingCustomize/>
                                : null
                        }
                    </KeyboardAvoidingView>
                </View>
            </View>

            //
            // {/*<View style={{marginTop: moderateScale(20)}}>*/}
            //     {/*<Image source={require("../../../..assets/img/logo.png")}*/}
            //            {/*style={{*/}
            //                {/*width: moderateScale(150),*/}
            //                {/*height: moderateScale(100),*/}
            //                {/*alignSelf: 'center',*/}
            //                {/*marginBottom: moderateScale(18)*/}
            //            {/*}}/>*/}
            //     {/*<HMTextInput*/}
            //         {/*value={this.state.code}*/}
            //         {/*onChangeText={text => this._changeText(text)} autoFocus keyboardType="numeric"*/}
            //         {/*placeholder="کدی که برای شما ارسال شده است" style={{*/}
            //         {/*width: "90%",*/}
            //         {/*fontFamily: "IRANSansMobile",*/}
            //         {/*fontSize: moderateScale(14)*/}
            //     {/*}} underlineColorAndroid="transparent"/>*/}
            //
            //     {/*/!*<AnimateLoadingButton*!/*/}
            //     {/*/!*ref={c => (this.loadingButton = c)}*!/*/}
            //     {/*/!*width={moderateScale(300)}*!/*/}
            //     {/*/!*height={verticalScale(50)}*!/*/}
            //     {/*/!*title="بررسی کد"*!/*/}
            //     {/*/!*titleFontFamily={Constants.regularFontName}*!/*/}
            //     {/*/!*containerStyle={{marginTop: moderateScale(20)}}*!/*/}
            //     {/*/!*titleFontSize={moderateScale(14)}*!/*/}
            //     {/*/!*titleColor="rgb(255,255,255)"*!/*/}
            //     {/*/!*backgroundColor={Colors.colorPrimary}*!/*/}
            //     {/*/!*borderRadius={4}*!/*/}
            //
            //     {/*/!*onPress={() => this.checkCode(this.state.code)}*!/*/}
            //     {/*/!*/>*!/*/}
            //
            //     {/*<TouchableOpacity style={{*/}
            //         {/*backgroundColor: Colors.colorPrimary,*/}
            //         {/*width: "85%",*/}
            //         {/*height: moderateScale(40),*/}
            //         {/*alignSelf:'center',*/}
            //         {/*alignItems: "center",*/}
            //         {/*justifyContent: "center",*/}
            //         {/*marginTop:moderateScale(10),*/}
            //         {/*borderRadius:moderateScale(6)*/}
            //     {/*}}*/}
            //                       {/*onPress={() => this.checkCode(this.state.code)}*/}
            //
            //     {/*>*/}
            //         {/*<View style={{flexDirection: "row", alignItems: "center", justifyContent: "center"}}>*/}
            //             {/*<HMTextView type={"bold"} text={"بررسی کد"} style={{*/}
            //                 {/*color: "white",*/}
            //                 {/*fontSize: moderateScale(16),*/}
            //                 {/*marginEnd: moderateScale(10)*/}
            //             {/*}}/>*/}
            //
            //         {/*</View>*/}
            //     {/*</TouchableOpacity>*/}
            // {/*</View>*/}
            //
            //


        );
    }
}
